import Page from '..';
import useStore from '../../Hooks/useStore';
import PageValidityStatus from './Status';
import PageValidityValidities from './Validities';

const PageValidity = () => {
  const [getters] = useStore();
  const {
    user: { getDashboard },
  } = getters;
  return (
    <Page className="page-banner">
      <div
        style={{
          position: 'relative',
          transition: 'min-width 500ms, max-width 500ms',
          width: '100%',
          minHeight: 'calc(100vh - 130px)',
          maxHeight: 'calc(100vh - 130px)',
          margin: '0 1rem',
          background: '#DDDDDD',
          borderRadius: '5px',
          overflow: 'hidden',
        }}
      >
        {/* <iframe
          style={{
            width: '100%',
            height: '100%',
          }}
          src={getDashboard()}
        ></iframe> */}
      </div>
    </Page>
  );
};

export default Object.assign(PageValidity, {
  Validities: PageValidityValidities,
  Status: PageValidityStatus,
});

// https://www.elastic.co/pt/blog/how-to-embed-kibana-dashboards
// https://www.elastic.co/guide/en/kibana/current/docker.html
